module.exports = "https://la-static.vkplay.ru/promo/newstart/img/location-2.21b5a4f8.jpg";